export default __webpack_public_path__ + "static/media/hht2_ep13_speaking_04.0c5683ca.png";